<template>
  <el-main class="page-content-margin-unset">
    <div class="dk-li">
      <h3 style="display:inline-block">订单信息</h3>
      <el-button type="primary" v-if="status == '待支付'" @click="event().onChangMoneyClick()">修改实际支付金额</el-button>
    </div>
    <el-table border :data="body">
      <el-table-column prop="order_id" label="订单号" />
      <el-table-column prop="create_time" label="创建时间" />
      <el-table-column prop="name" label="用户昵称" />
      <el-table-column prop="mobile" label="手机号" />
      <el-table-column prop="money" label="订单金额" />
      <el-table-column prop="paid_money" label="实际支付金额" />
      <el-table-column prop="pay_type" label="支付方式">
        <template slot-scope="scope">
          <span>{{ ['','微信','支付宝','线下'][scope.row.pay_type] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="pay_time" label="支付时间" />
      <el-table-column prop="status" label="订单状态" />
      <el-table-column prop="cash" label="积分抵扣" />
      <el-table-column prop="invite_code" label="推荐人ID" />
    </el-table>
    <h3>收货地址</h3>
    <el-table border :data="address">
      <el-table-column prop="name" label="收货人">
        <template slot-scope="scope">
          <el-input v-model="scope.row.name"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="联系电话">
        <template slot-scope="scope">
          <el-input v-model="scope.row.mobile"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="收货地址 (省-市-区)">
        <template slot-scope="scope">
          <el-cascader
            v-model="scope.row.address_arr"
            :options="cityList"
            :props="{ value: 'name',label:'name',children:'districts', checkStrictly: true }"
            filterable></el-cascader>
        </template>
      </el-table-column>
      <el-table-column label="收货地址 (地址)">
        <template slot-scope="scope">
          <!-- <span>
            {{ scope.row.province }}
            {{ scope.row.city }}
            {{ scope.row.county }}
            {{ scope.row.detail_address }}
          </span>-->
          <el-input v-model="scope.row.detail_address"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <h3>商品信息</h3>
    <el-table border :data="product">
      <!-- <el-table-column label="商品图片">
        <template slot-scope="scope">
          <img width="148px" :src="imgDomain + scope.row.img_src" alt />
        </template>
      </el-table-column>-->

      <el-table-column align="center" prop="product_name" label="商品标题">
        <template slot-scope="scope">
          <el-select
            filterable
            remote
            reserve-keyword
            :remote-method="chageSelectGoods"
            v-model="product[scope.$index].product_uuid"
            :loading="loading"
            @change="(value) => setGoodsNormAtChange(value, scope.$index)"
          >
            <el-option
              v-for="item in goodsOpation"
              :key="item.uuid"
              :label="item.title"
              :value="item.uuid"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="standard_name" label="商品规格">
        <template slot-scope="scope">
          <el-select
            v-model="product[scope.$index].standard_uuid"
            @change="(value) => changeStandard(value, scope.$index)"
          >
            <el-option
              v-for="item in goodsNormOpation[scope.$index]"
              :key="item.uuid"
              :label="item.name"
              :value="item.uuid"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="数量">
        <template slot-scope="scope">
          <el-input
            :disabled="scope.row.standard_uuid === '' || scope.row.product_uuid === '' ||
                        scope.row.standard_uuid === undefined || scope.row.product_uuid === undefined"
            v-model="scope.row.quantity"
            @change="event().quantityChangeEvent(scope.$index)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="paid_money" label="商品价格" />
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="event().removeProductTableRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" style="text-align: center;">
      <el-button @click="event().addProductTableRow()" style="width:100%">新 建</el-button>
    </el-col>

    <!-- 修改实际金额 -->
    <el-dialog width="480px" title="修改金额" :visible.sync="changeMoneyDialog">
      <el-form
        :model="changeMoneyBody"
        label-position="left"
        :rules="rules3"
        ref="ruleForm3"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="实际支付金额：" prop="paid_money">
          <el-input class="dk-input" v-model.number="changeMoneyBody.paid_money" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeMoneyDialog = false">取 消</el-button>
        <el-button type="primary" @click="event().onSureChangeMoneyClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>
    <el-col :span="24" style="text-align: center;margin-top:20px">
      <el-button @click="event().returnBackPage()">返 回</el-button>
      <el-button type="primary" @click="saveOrderEdit()">保 存</el-button>
    </el-col>
  </el-main>
</template>

<script>
import { getOrderDetail, chengMoney, updateOrder } from "../../api/order";
import { imgDomain } from "../../configs/env";
import { getStandardList, getCommodityList } from "../../api/commodity";
import object from "../../jslib/object";

import {
  getCity
} from '../../api/content'
export default {
  data() {
    // eslint-disable-next-line
    const checkMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("支付金额不能为空"));
      }
      if (!(/^\d+(\.\d{1,2})?$/.test(value))) {
        callback(new Error("请输入数字值"));
      } else {
        callback();
      }
    };
    return {
      imgDomain,
      loading: false,
      conditionTitle: false,
      conditionDialog: true,
      status: "",
      body: [],
      product: [],
      netProduct: [],
      add_product: [],
      delete_product: [],
      logistics: [],
      logisticsDetail: [],
      goodsOpation: [],
      goodsNormOpation: [],
      tempPrice: 0,
      // 修改待支付金额
      changeMoneyDialog: false,
      changeMoneyBody: {
        paid_money: "",
      },
      rules3: {
        paid_money: [{ validator: checkMoney, trigger: "blur" }],
      },
      address: [{
        name: '',
        mobile: '',
        address_arr: [],
        detail_address: '',
      }],
      cityList: [],
    };
  },
  created() {
    this.network().getOrderDetail();
    this.network().getCity()
  },
  mounted() {
    this.network().getCommodityList();
  },
  methods: {
    setGoodsNormAtChange(value, index) {
      this.$set(this.product[index],'standard_uuid', '')
      this.$set(this.product[index],'paid_money', 0)
      this.network().getStandardList(value, index);
      this.event().countPrice();
    },
    chageSelectGoods(value) {
      this.network().getCommodityList(value);
    },
    changeStandard(value, index) {
      this.event().quantityChangeEvent(index)
    },
    saveOrderEdit() {
      let params = {}
      if (this.address[0].detail_address === '') {
        return this.$message('详细地址不能为空');
      }
      params.order_uuid = this.body[0].order_uuid;
      params.address_uuid = this.body[0].address.uuid;
      params.name = this.body[0].address.name;
      params.mobile = this.body[0].address.mobile;
      params.address = this.address[0].address_arr.join(' ') + ' ' + this.address[0].detail_address;
      params.money = this.body[0].money;
      params.product =  this.product;
      params.delete_product = this.delete_product;
      this.network().updateOrder(params);
    },
    event() {
      return {
        quantityChangeEvent: (index) => {
          let nromuuid = this.product[index].standard_uuid;
          console.log(nromuuid);
          let singPrice = 0.0;
          this.goodsNormOpation[index].forEach((item) => {
            if (item.uuid === nromuuid) {
              singPrice = parseFloat(item.price);
            }
          });
          console.log(singPrice, "单价");
          if (singPrice === 0) {
            if (this.tempPrice === 0) {
              this.tempPrice = parseFloat(this.product[index].price);
            }

            this.product[index].paid_money =
              this.tempPrice * parseFloat(this.product[index].quantity);
          } else {
            this.product[index].paid_money =
              parseFloat(this.product[index].quantity) * singPrice;
          }
          this.event().countPrice();
        },
        countPrice: () => {
          //计算总金额
          let orderCount = 0;
          this.product.forEach((item) => {
            orderCount += parseFloat(item.paid_money);
          });
          this.body[0].money = orderCount;
        },
        returnBackPage: () => {
          this.$router.push({ path: "list" });
        },
        removeProductTableRow: (index) => {
          let uuid = this.product[index].uuid;
          if (uuid) {
            this.delete_product.push(uuid);
          }
          this.product.splice(index, 1);
          this.goodsNormOpation.splice(index, 1);
          this.event().countPrice();
        },
        addProductTableRow: () => {
          this.product.push({
            img_src: "",
            paid_money: "",
            price: "",
            product_name: "",
            quantity: 0,
            standard_name: "",
          });
        },

        onChangMoneyClick: () => {
          this.changeMoneyBody.paid_money = this.body[0].paid_money;
          this.changeMoneyBody.uuid = this.body[0].order_uuid;
          this.changeMoneyDialog = true;
        },
        onSureChangeMoneyClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.network().chengMoney();
            } else {
              console.log("error submit!!");
            }
          });
        },
      };
    },
    network() {
      return {
        getCity: async () => {
          const { status, data } = await getCity()
          if (status !== 200) return
          for (let item of data) {
            for (let i of item.districts) {
              for (let j of i.districts) {
                delete j.districts
              }
            }
          }
          this.cityList = data
        },
        getStandardList: async (value, index) => {
          let params = {
            product_uuid: value,
          };
          const { status, data } = await getStandardList(params);
          this.$set(this.goodsNormOpation, index, data.list);
        },
        updateOrder: async (params) => {
          const { status, data } = await updateOrder(params);
          if (status !== 200) return
          this.$notify({
            title: '编辑成功',
            message: '编辑订单成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
        c: async (value, index) => {
          let params = {
            product_uuid: value,
          };
          const { status, data } = await getStandardList(params);
          this.$set(this.goodsNormOpation, index, data.list);
        },
        getCommodityList: async (value) => {
          let params = {
            status: 0,
          };
          if (value) {
            params.keyword = value;
          }
          const { status, data } = await getCommodityList(params);
          this.goodsOpation = data.data;
        },

        getOrderDetail: async () => {
          const { status, data } = await getOrderDetail(this.$route.query.uuid);
          if (status !== 200) return;
          this.body = [data];
          this.status = data.status;
          this.product = data.product;
          this.netProduct = data.product;
          this.address = [data.address];
          this.logisticsDetail = data.logistics_detail;
          this.logistics = [data.logistics];
          this.product.map((item, index) => {
            this.network().getStandardList(item.product_uuid, index);
          })
          console.log(this.goodsNormOpation)
        },
        chengMoney: async () => {
          const { status } = await chengMoney(this.changeMoneyBody);
          if (status !== 200) return;
          this.network().getOrderDetail();
          this.changeMoneyDialog = false;
          this.$notify({
            title: "修改成功",
            message: "实际金额修改成功",
            type: "success",
          });
        },
      };
    },
    handler() {
      return {};
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/mixins.scss";
.page-content-margin-unset {
  .dk-from {
    display: flex;
  }
  .table-top {
    @include dk-table-top;
  }
}
</style>



// WEBPACK FOOTER //
// src/vuepage/order/order-edit.vue